import { CloseSquareLight, DoneLight } from '@repo/go-icons';
import { Button, Field, Input } from '@repo/go-ui';
import type { i18n } from 'i18next';
import { Controller, useForm } from 'react-hook-form';

type CreateTemplateFormFields = {
  name: string;
  description: string;
};

type TLabel = {
  name: string;
  description: string;
  errorTextMaxLength: string;
  submitButtonMessage: string;
  cancelButtonMessage: string;
};
type CreateTemplateFormProps = {
  defaultValues?: CreateTemplateFormFields;
  onSubmit: (values: CreateTemplateFormFields) => void;
  onCancel: () => void;
  labels: TLabel;
  maxNameLength?: number;
  maxDescriptionLength?: number;
  i18n: i18n;
};
export function CreateTemplateForm({
  onSubmit,
  onCancel,
  defaultValues = {
    name: '',
    description: '',
  },
  labels,
  maxNameLength = 40,
  maxDescriptionLength = 120,
  i18n,
}: CreateTemplateFormProps) {
  const { control, handleSubmit } = useForm<{
    name: string;
    description: string;
  }>({
    defaultValues,
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="name"
        rules={{
          required: true,
          maxLength: maxNameLength,
        }}
        render={({ field, fieldState }) => (
          <Field
            label={i18n.t(labels.name)}
            status={fieldState.error ? 'error' : undefined}
            hint={fieldState.error ? i18n.t(labels.errorTextMaxLength, { maxLength: maxNameLength }) : undefined}
            style={{ marginBottom: 8 }}
          >
            <Input value={field.value} onChange={field.onChange} />
          </Field>
        )}
      />
      <Controller
        control={control}
        name="description"
        rules={{
          maxLength: maxDescriptionLength,
        }}
        render={({ field, fieldState }) => (
          <Field
            label={i18n.t(labels.description)}
            status={fieldState.error ? 'error' : undefined}
            hint={fieldState.error ? i18n.t(labels.errorTextMaxLength, { maxLength: maxDescriptionLength }) : undefined}
          >
            <Input value={field.value} onChange={field.onChange} />
          </Field>
        )}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 16,
          marginTop: 16,
        }}
      >
        <Button variant="danger" onClick={onCancel} icon={<CloseSquareLight />}>
          {i18n.t(labels.cancelButtonMessage)}
        </Button>
        <Button type="submit" variant="success" icon={<DoneLight />}>
          {i18n.t(labels.submitButtonMessage)}
        </Button>
      </div>
    </form>
  );
}
